var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrdtIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "card-header-icon",
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm.95-12.58l.94-2.31C8.99 2.51 9.47 2.1 10 2H18c.55 0 1 .45 1 1s-.45 1-1 1H11.21l-.94 2.31L13 10h4.55c.67 0 1.25.39 1.52.97l3.58 6.49c.37.67.04 1.53-.65 1.53H7.42c-.42 0-.81-.25-.96-.64L3.01 4H1c-.55 0-1-.45-1-1s.45-1 1-1h2.19l3.76 9.42.01.01z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrdtIco);
export default __webpack_public_path__ + "static/media/prdt-ico.2eac55d1e3059f68225ac703320d2881.svg";
export { ForwardRef as ReactComponent };